export default ({ attach, ICON }) => ({
  MuiSvgIcon: {
    root: {
      fontSize: 25,
      cursor: 'pointer'
    },
    colorError: {
      paddingRight: 10
    }
  },
  MuiIcon: {
    root: {
      fontSize: 25,
      cursor: 'pointer'
    }
  }
});
